/**
 * {@link required} displays a red star near the title when true
 * {@link maxListEntryLength} max number of chars displayed in selector picker
 * {@link openOnClick} set false to open selector on hover
 */
export class SelectorProps {
  required = false;
  maxListEntryLength = -1; // not limited by default (when = -1)
  openOnClick = true;
}

/**
 * There are two types of entries: header and subheader.
 * In html, header will be displayed at the top and subheader at the bottom.
 * In html, only subheader can be chosen, header cannot be chosen.
 * In code, header and subheader are separate entries.
 * <p>
 * For header:
 * <pre>
 * id: all subheaders for the header, divided by ','. This is needed for filtering both subheader and header at the same time.
 * header: the header title itself
 * subheader: null
 * isHeader: true
 * </pre>
 * For subheader:
 * <pre>
 * id: unique subheader, which will be checked with 'selectedItem' to add extra `selected` style.
 * header: the header of the subheader.
 * subheader: string
 * isHeader: false
 * </pre>
 *
 */
export class SelectorAutocompletePickerWrapper {
  constructor(
    public id: string,
    public header: string,
    public subheader: string,
    public isHeader: boolean,
    public comment: string,
  ) {
  }
}
